import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import utc from 'dayjs/plugin/utc'

// AdvancedFormat extends `dayjs().format` API to supply more format options.
// E.g. `dayjs().format('Q Do k kk X x')`
dayjs.extend(advancedFormat)

// CustomParseFormat extends `dayjs()` constructor to support custom formats of input strings.
// E.g. `dayjs('05/02/69 1:02:03 PM -05:00', 'MM/DD/YY H:mm:ss A Z')`
dayjs.extend(customParseFormat)

// adds .utc .local .isUTC APIs to parse or display in UTC.
dayjs.extend(utc)

dayjs.extend(isSameOrAfter)

export { dayjs }
